<template lang="html">
	<tr>
		<!-- Select All -->
		<table-cell :has-checkbox="true">
			<input-checkbox
				:id="'select-' + id"
				:checked="-1 !== $store.state.monsterleads.bulk.indexOf(id)"
				:value="id"
				:name="'select-' + id"
				class="lead-select-wrapper"
				@input="changeCheckbox"
			/>
		</table-cell>
		<table-cell class="monsterleads-table-name name column-name has-row-actions column-primary">
			<template v-if="fullName">{{ fullName }}</template>
			<em v-else>Unknown</em>
			<div class="row-actions">
				<span class="view"><a href="#" @click.prevent="viewLead">View Lead</a></span> |
				<span v-if="mailto" class="email"><a :href="mailto">Email</a></span> |
				<span class="delete"><a href="#" @click.prevent="maybeDeleteLead">Delete</a></span>
			</div>
		</table-cell>
		<table-cell class="monsterleads-table-email">
			{{ email }}
		</table-cell>
		<table-cell class="monsterleads-table-date">
			{{ created }}
		</table-cell>
		<table-cell class="monsterleads-table-actions">
			<common-tooltip
				class="action-monsterleads-view"
				tooltip="View Lead Information"
				:icon="false"
				:delay-on-mouse-over="0"
			>
				<core-button color="white" size="icon" @click.prevent="viewLead">
					<i class="fa fa-eye" alt="View Lead"></i>
				</core-button>
			</common-tooltip>
			<common-tooltip
				v-if="mailto"
				class="action-monsterleads-email"
				tooltip="Send Email"
				:icon="false"
				:delay-on-mouse-over="0"
			>
				<core-button color="white" size="icon" :is-link="true" :href="mailto">
					<i class="fa fa-envelope-o" alt="Mail"></i>
				</core-button>
			</common-tooltip>
			<common-tooltip class="action-delete-lead" tooltip="Delete Lead" :icon="false" :delay-on-mouse-over="0">
				<core-button color="white" size="icon" @click.prevent="maybeDeleteLead">
					<i class="fa fa-trash-o" alt="Trash"></i>
				</core-button>
			</common-tooltip>
		</table-cell>
	</tr>
</template>

<script lang="js">
import { lead } from '@/monsterleads/mixins/lead'

export default {
	mixins : [ lead ],
	props  : {
		lead : {
			type     : Object,
			required : true,
		},
	},
	methods : {
		/**
		 * Take the appropriate action when a checkbox is checked/unchecked.
		 * @param {boolean} value is the checkbox checked
		 * @param {string} checked the lead id
		 * @returns {void}
		 */
		changeCheckbox (value, checked) {
			if (checked) {
				this.addToBulk()
			} else {
				this.removeFromBulk()
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/variables';

.monsterleads-table-actions {
	a,
	button {
		display: inline;
		height: 36px;
		width: 36px;
	}
}
</style>
